function checkScrollbar() {
  //Get real width of page scroll-bar
  const w1 = document.documentElement.clientWidth;
  document.querySelector('html').classList.add('popup_lock');
  const w2 = document.documentElement.clientWidth;
  document.querySelector('html').classList.remove('popup_lock');
  return w2 - w1;
}


// FULL POPUP STUFF
function bodyStopScroll() {
  const scrollWidth = checkScrollbar();
  const stopScrollStyle = `
      <style id="scrollStuff">
        html {overflow: hidden;}
        body, .js_noscrol_pad { padding-right: ${scrollWidth}px; }
        body { width:auto; }
      </style>
    `;
  document.head.insertAdjacentHTML('beforeend', stopScrollStyle);
  document.body.classList.add('noscroll');
}
function bodyRemoveStopScroll() {
  if (document.head.querySelector('#scrollStuff')) {
    document.head.querySelector('#scrollStuff').remove();
  }
  document.body.classList.remove('noscroll');
}
// ==============



// let's get this party started
document.addEventListener('DOMContentLoaded', function () {




  // INPUT STATUS
  function checkFill(item) {
    item.value.length
      ? item.classList.add('m-filled')
      : item.classList.remove('m-filled');
  }


  document.querySelectorAll('.js_checkfill').forEach(item => {
    checkFill(item)
    item.onfocus = function () {
      item.classList.add('m-focused');
    }
    item.onblur = function () {
      item.classList.remove('m-focused');
      checkFill(item)
    }
    item.onkeyup = function () {
      checkFill(item)
    }
  });


  // ========================

  // INPUT CLEAR
  document.querySelectorAll('.js_input_clear').forEach(item => {
    item.addEventListener('click', (e) => {
      e.preventDefault();
      const targetInputs = item.parentNode.querySelectorAll('input, textarea');
      targetInputs.forEach(input => {
        input.value = '';
        input.classList.remove('m-filled');
        input.focus();
      });
    });
  });

  // ========================

  // STUFF ON SCROLL
  function onScroll() {
    // detect scroll
    const scrolledGap = 42;
    const scrollTop = (window.scrollY !== undefined) ? window.scrollY : (document.documentElement || document.body.parentNode || document.body).scrollTop;
    scrollTop > scrolledGap
      ? document.body.classList.add('m-scrolled')
      : document.body.classList.remove('m-scrolled');
    // =========
  }
  onScroll();
  let throttlescroll;
  window.addEventListener('scroll', function () {
    clearTimeout(throttlescroll)
    throttlescroll = setTimeout(function () {
      onScroll();
    }, 50)
  }, false)
  // ========================

  // SCROLL TO
  const scroller = new SweetScroll(
    {
      /* some options */
      trigger: '[data-scroll]',       // Selector for trigger (must be a valid css selector)
      header: '[data-scroll-header]', // Selector or Element for fixed header (Selector of must be a valid css selector)
      // header: '#header',
      duration: 500,                 // Specifies animation duration in integer
      easing: 'easeInOutSine',         // Specifies the pattern of easing
      offset: 0,                      // Specifies the value to offset the scroll position in pixels
      vertical: true,                 // Enable the vertical scroll
      horizontal: false,              // Enable the horizontal scroll
      cancellable: true,              // When fired wheel or touchstart events to stop scrolling
      updateURL: false,               // Update the URL hash on after scroll (true | false | 'push' | 'replace')
      preventDefault: true,           // Cancels the container element click event
      stopPropagation: true,          // Prevents further propagation of the container element click event in the bubbling phase

      // Callbacks
      // before: null,
      after: (offset, $trigger, scroller) => {
        // move focus to target
        let targetItem;
        if (!$trigger && offset.top === 0) {
          targetItem = document.body;
        } else if ($trigger && $trigger.getAttribute('href')) {
          targetItem = document.querySelector($trigger.getAttribute('href'));
        } else if ($trigger && $trigger.getAttribute('data-scroll').substring(0, 1) === '#') {
          targetItem = document.querySelector($trigger.getAttribute('data-scroll'));
        }
        if (targetItem) {
          targetItem.focus();
          if (targetItem !== document.activeElement) {
            targetItem.setAttribute('tabindex', '-1');
            targetItem.focus();
            targetItem.blur();
            targetItem.removeAttribute('tabindex');
          }
        }
      },
    },
  );

  document.querySelectorAll('[data-scroll-top]').forEach(item => {
    item.addEventListener('click', (e) => {
      e.preventDefault();
      scroller.toTop(0);
    });
  });
  //===============================




  // SLIDEDOWN
  let slideHold = false;
  const slideUp = (target, duration = 500) => {
    slideHold = true;
    target.classList.remove('m-active');
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout(() => {
      target.style.display = 'none';
      target.style.removeProperty('height');
      target.style.removeProperty('padding-top');
      target.style.removeProperty('padding-bottom');
      target.style.removeProperty('margin-top');
      target.style.removeProperty('margin-bottom');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
      slideHold = false;
    }, duration);
  }
  const slideDown = (target, duration = 500) => {
    target.classList.add('m-active');
    slideHold = true;
    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;
    if (display === 'none') display = 'block';
    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    window.setTimeout(() => {
      target.style.removeProperty('height');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
      slideHold = false;
    }, duration);
  }
  const slideToggle = (target, duration = 500) => {
    return window.getComputedStyle(target).display === 'none'
      ? slideDown(target, duration)
      : slideUp(target, duration);
  }

  document.querySelectorAll('.js_slidedown_trigger').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      if (!slideHold) {
        let slideDuration = trigger.getAttribute('data-duration')
          ? trigger.getAttribute('data-duration')
          : 500;
        let thisTarget = trigger.getAttribute('data-target')
          ? document.querySelector(trigger.getAttribute('data-target'))
          : trigger.closest('.js_slidedown').querySelector('.js_slidedown_content');
        slideToggle(thisTarget, slideDuration);
        if (trigger.classList.contains('m-active')) {
          trigger.classList.remove('m-active');
          if (trigger.closest('.js_slidedown')) {
            trigger.closest('.js_slidedown').classList.remove('m-active');
          }
        } else {
          trigger.classList.add('m-active');
          if (trigger.closest('.js_slidedown')) {
            trigger.closest('.js_slidedown').classList.add('m-active');
          }
        }
      }
    });
  });
  // ========================

  // ACTIVE TOGGLE
  let toggleHold = false;
  document.querySelectorAll('.js_toggle_trigger').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      if (!toggleHold && !trigger.classList.contains('m-asc') && !trigger.classList.contains('m-desc')) {

        toggleHold = true;
        let toggleTarget = ''
        if (trigger.getAttribute('data-target')) {
          toggleTarget = document.querySelector(trigger.getAttribute('data-target'))
        } else if (trigger.getAttribute('href')) {
          toggleTarget = document.querySelector(trigger.getAttribute('href'))
        } else {
          toggleTarget = trigger.closest('.js_toggle');
        }
        trigger.classList.toggle('m-active');
        toggleTarget.classList.toggle('m-active');

        setTimeout(() => {
          toggleHold = false;
        }, 500);
      }
    });
  });
  // ========================


  // FULL POPUP STUFF

  document.querySelectorAll('.js_popup_trigger').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const popupTarget = trigger.getAttribute('href')
        ? document.querySelector(trigger.getAttribute('href'))
        : document.querySelector(trigger.getAttribute('data-target'));
      bodyStopScroll();
      popupTarget.classList.add('m-active');

      trigger.classList.add('focusHolder');

      setTimeout(() => {
        popupTarget.setAttribute('tabindex', '-1');
        popupTarget.focus();
        popupTarget.blur();
        popupTarget.removeAttribute('tabindex');
      }, 500);
    });
  });


  document.querySelectorAll('.js_popup_close').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      closePopup();
    });
  });


  let isEsc = false;
  document.addEventListener('keyup', function (event) {
    if (event.key === "Escape") {
      isEsc = true;
      closePopup();
    }
  });

  function closePopup() {
    const activePopup = document.querySelector('.js_popup.m-active');
    if (activePopup) {
      activePopup.classList.remove('m-active');
      setTimeout(() => {
        bodyRemoveStopScroll();

        const focusTarget = document.querySelector('.focusHolder');
        if (focusTarget) {
          focusTarget.focus();
          if (!isEsc) {
            focusTarget.blur();
          }
          focusTarget.classList.remove('focusHolder');
        }
        isEsc = false;
      }, 300);
    }
    else {
      isEsc = false;
    }
  }


  // ==========================


  let stopscrollHold = false;
  document.querySelectorAll('.js_stopscroll').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      if (!stopscrollHold) {
        stopscrollHold = true;
        if (!document.body.classList.contains('noscroll')) {
          bodyStopScroll();
        } else {
          setTimeout(() => {
            bodyRemoveStopScroll();
          }, 500);
        }
        setTimeout(() => {
          stopscrollHold = false;
        }, 500);
      }
    });
  });


  // ON HORIZONTAL RESIZE
  // - remove bodystopscroll
  let winWidth = window.innerWidth;
  let throttleresize;
  window.addEventListener('resize', function () {
    let newWinWidth = window.innerWidth;
    if (newWinWidth !== winWidth) {
      newWinWidth = newWinWidth;
      clearTimeout(throttleresize)
      throttleresize = setTimeout(function () {

        if (document.head.querySelector('#scrollStuff')) {
          bodyRemoveStopScroll();
        }

      }, 150)
    }
  }, false)


});


// =================================================
// =================================================
// =================================================

